import { getLabel } from '@weapp/utils';
import { observable, action, runInAction, toJS } from "mobx";

import { pcSkinStore } from '../../../store/pc/index';
import * as LoginAPI from '../../../api/pc/login';
import { inPCRouteWhiteList, inCustomLogin, inLoginPage, getQueryString } from '../../../utils';
import { Dialog } from "@weapp/ui";
import { publicUrl, publicUrlapi } from "../../../constants";
const { message } = Dialog;

export class MainStore {
  @observable navmenus: any = []//默认导航链接
  @observable tgtChecked: boolean = false;//是否校验了tgt
  @observable runInfoChecked: boolean = false;//获取登录信息
  @observable isEbDesign: boolean = false;//eb设计器设计模式
  // @observable isPrivateLogin: boolean = false;

  @action
  init = (source: string = '', isDesign: boolean = false) => {
    if (isDesign) {
      this.isEbDesign = true;
    }
    const pathname = window.location.pathname.replace(publicUrl, '');
    if (!inPCRouteWhiteList() && !inCustomLogin() && !source) {
      // 未知地址全部走一次customlogin
      window.location.href = `${publicUrl}/customlogin${pathname}`;
    }

    LoginAPI.getUrlInfo('pc').then((result: any) => {
      runInAction(async () => {

        if (result.data?.weappUrl) {
          const service = getQueryString('service');
          const serviceStr = decodeURIComponent(service);

          const isServiceFreePass = service && (
            serviceStr.indexOf('intunifyauth_client=freepass') !== -1 ||
            serviceStr.indexOf('wea_link_keep_intunifyauth_client=freepass') !== -1
          );

          const isPassIntunifyauth = (
            getQueryString('intunifyauth_client') === 'freepass' ||
            getQueryString('wea_link_keep_intunifyauth_client') === 'freepass' ||
            isServiceFreePass
          );

          if (!isPassIntunifyauth && inLoginPage()) {
            if (result?.data?.intunifyAuthDomainCheck === 'on') {//集成登录配置调用
              try {
                let initunifyOpen = await this.checkIntunifyauthByDomain();
                if (initunifyOpen) {
                  return;
                }
              } catch (error) {

              }

            }

            //集成登录全拦截开启
            if (result.data?.intunifyauthOpen === 'true' && result.data?.intunifyauthUrl) {
              const intunifyauthUrl = result.data.intunifyauthUrl.replace(publicUrlapi, '');
              if (service) {
                window.location.href = `${result.data.weappUrl}${publicUrlapi}${intunifyauthUrl}${intunifyauthUrl.indexOf('?') !== -1 ? '&' : '?'}oaUrl=${encodeURIComponent(result.data.weappUrl + publicUrl)}&passportUrl=${encodeURIComponent(result.data.passportUrl)}${service ? `&oaAddress=${encodeURIComponent(serviceStr)}` : ``}`;
              } else {
                window.location.href = `${result.data.weappUrl}${publicUrlapi}${intunifyauthUrl}${intunifyauthUrl.indexOf('?') !== -1 ? '&' : '?'}oaUrl=${encodeURIComponent(result.data.weappUrl + publicUrl)}&passportUrl=${encodeURIComponent(result.data.passportUrl)}&oaAddress=${result.data.weappUrl}${publicUrl}`;
              }
              return;
            }
          }
          window.passport_runInfo = result.data;
          window.passport_brand = result.data.urlTitle || 'eteams';
          document.title = document.title.replace('eteams', window.passport_brand);
          runInAction(() => {
            this.runInfoChecked = true;
          })
          // window.passport_runInfo.deployEnv = 'private';
        }

        if (!inPCRouteWhiteList() || inLoginPage()) {
          //是eb组件，且在设计器或预览中使用
          if (source === 'eb' && !window.inPassportEbpage) {
            this.tgtChecked = true;
          } else {
            this.checkLogin();
          }
        } else {
          this.tgtChecked = true;
        }

        pcSkinStore.init();
      });

    });
  }
  @action
  checkIntunifyauthByDomain = () => {
    return new Promise<boolean>((resolve, reject) => {
      let domain = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');
      LoginAPI.checkIntunifyauthByDomain(domain, 'pc').then((result) => {
        if (result?.data?.errorMsg) {
          const msg = result.data.errorMsg
          message({
            type: "error",
            content: getLabel(msg.i18nId, msg.msg),
            delay: 2000
          });
          resolve(false)
        } else {
          if (result.data.relativeUrl) {
            window.location.href = `${window.passport_runInfo?.weappUrl || ''}${result.data.relativeUrl}${result.data.relativeUrl.indexOf('?') !== -1 ? '&' : '?'}redirect_uri=${encodeURIComponent(window.passport_runInfo?.weappUrl || '')}`
            resolve(true)
          } else if (result?.data?.redirectUrl) {
            window.location.href = result.data.redirectUrl;
            resolve(true)
          } else {
            resolve(false)
          }
        }
      }).catch((error) => {
        console.log(error);
        runInAction(() => {
          resolve(false)
        });
      });
    })

  }
  // @action
  // checkPrivateLoginPage = () => {
  //   const path = window.location.pathname;
  //   if ((path === '/' || path === '/login') && window.passport_runInfo.deployEnv === 'private') {
  //     this.isPrivateLogin = true;
  //   } else {
  //     this.isPrivateLogin = false;
  //   }
  // }
  // TGT过期情况
  @action
  checkLogin = () => {
    LoginAPI.checkLogin().then((result: any) => {
      if (result?.data?.errorMsg) {
        const msg = result.data.errorMsg
        message({
          type: "error",
          content: getLabel(msg.i18nId, msg.msg),
          delay: 2000
        });
        runInAction(() => {
          this.tgtChecked = true;
        })
      } else {
        if (result?.data?.redirectUrl) {
          window.location.replace(result.data.redirectUrl);
        } else {
          runInAction(() => {
            this.tgtChecked = true;
          })
        }
      }

    }).catch((error) => {
      runInAction(() => {
        this.tgtChecked = true;
      })
    });
  }
}

const instance = new MainStore();
export default instance;
export type MainStoreType = Pick<MainStore, keyof MainStore>;
